// extracted by mini-css-extract-plugin
export default {"routeArea":"styles_routeArea__+FLP+","text-crumb":"styles_text-crumb__YHbUK"};